export const autoplayProps = {
  delay: 5000,
  disableOnInteraction: false,
  pauseOnMouseEnter: true
};
